import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'hooks';
import { classNames } from 'utils/classNames';
import { IAddressesInfoSectionProps } from './types';
import styles from './AddressesInfoSection.module.css';
import { Flex, Tooltip } from 'antd';
import { ArrowRightOutlined, ShopOutlined, UserOutlined } from '@ant-design/icons';

const ArrowIcon: FC = () => {
	const { isRTL } = useSettings();

	// ! render
	return <ArrowRightOutlined rotate={isRTL ? 180 : 0} />;
};

const AddressesInfoSection: FC<IAddressesInfoSectionProps> = ({ pickupAddress, deliveryAddress }) => {
	const { t: tDispatcher } = useTranslation('dispatcher');

	const tooltipTitle = (
		<Flex
			gap='small'
			align='center'
			vertical
		>
			<div>
				<ShopOutlined /> {tDispatcher('order_card.pickup_address')}
			</div>
			<ArrowIcon />
			<div>
				<UserOutlined /> {tDispatcher('order_card.delivery_address')}
			</div>
		</Flex>
	);

	// ! handlers
	const onAddressesSectionClick = () => {
		const startLat = encodeURIComponent(pickupAddress.lat);
		const startLng = encodeURIComponent(pickupAddress.lng);
		const endLat = encodeURIComponent(deliveryAddress.lat);
		const endLng = encodeURIComponent(deliveryAddress.lng);

		const googleMapsDirectionBaseUrl = 'https://www.google.com/maps/dir/';
		const googleMapsDirectionLink = `${googleMapsDirectionBaseUrl}${startLat},${startLng}/${endLat},${endLng}`;

		// open google maps
		window.open(googleMapsDirectionLink, '_blank');
	};

	// ! render
	return (
		<Tooltip title={tooltipTitle}>
			<Flex
				gap='small'
				className={classNames(styles.addresses_info_section, styles.with_pointer_cursor)}
				onClick={onAddressesSectionClick}
			>
				<ShopOutlined />
				<ArrowIcon />
				<UserOutlined />
			</Flex>
		</Tooltip>
	);
};

export default memo(AddressesInfoSection);
